export type TasksRouteFrom = 'storefront' | 'profile' | 'quests' | 'onboarding';

export type Route =
  | { name: 'storefront' }
  | { name: 'chat'; modelId: string }
  | { name: 'profile' }
  | { name: 'tasks'; from?: TasksRouteFrom }
  | { name: 'gifts' }
  | { name: 'not_found' };

function parseTasksRouteFrom(raw: string | null): TasksRouteFrom | undefined {
  const value = String(raw || '').trim();
  if (value === 'profile' || value === 'storefront' || value === 'quests' || value === 'onboarding') return value;
  return undefined;
}

export function parseRoute(url: URL): Route {
  const path = url.pathname.replace(/\/+$/, '') || '/';

  if (path === '/') return { name: 'storefront' };
  if (path === '/profile') return { name: 'profile' };
  if (path === '/tasks') {
    const from = parseTasksRouteFrom(url.searchParams.get('from'));
    return { name: 'tasks', from };
  }
  if (path === '/gifts') return { name: 'gifts' };
  // Topup is implemented as a sheet, not a route. Keep legacy URL redirecting to storefront.
  if (path === '/topup') return { name: 'storefront' };
  if (path === '/chat') {
    const modelId = url.searchParams.get('model') || '';
    if (modelId) return { name: 'chat', modelId };
    return { name: 'not_found' };
  }

  return { name: 'not_found' };
}

export function buildUrl(route: Route): string {
  switch (route.name) {
    case 'storefront':
      return '/';
    case 'profile':
      return '/profile';
    case 'tasks':
      return route.from ? `/tasks?from=${encodeURIComponent(route.from)}` : '/tasks';
    case 'gifts':
      return '/gifts';
    case 'chat':
      return `/chat?model=${encodeURIComponent(route.modelId)}`;
    case 'not_found':
      return '/';
  }
}

